import { of, zip } from "rxjs";
import {
  distinctUntilChanged,
  filter,
  groupBy,
  map,
  mergeMap,
  switchMap,
} from "rxjs/operators";

export const MaterialSwitchSystem = (world, props = {}) => {
  world.data.entity$
    .pipe(
      groupBy(
        (entity) => entity.id,
        (entity) => entity
      ),
      mergeMap((group$) =>
        group$.pipe(
          // filter non
          filter(
            (entity) =>
              entity.hasOwnProperty("object3D") &&
              entity.object3D &&
              entity.hasOwnProperty("materialSwitch") &&
              entity.materialSwitch
          ),

          // insert object3D
          switchMap((definition) => {
            if (definition.object3D) {
              return world.object3DManager
                .getObject3D$(definition.object3D)
                .pipe(map((object3D) => ({ definition, object3D })));
            } else {
              return of({ definition });
            }
          }),

          // false --> pass
          /* distinctUntilChanged(
            (prev, curr) =>
              prev.definition.material === curr.definition.material &&
              prev.object3D === curr.object3D
          ), */

          // insert material
          switchMap((result) => {
            const {
              definition: { materialSwitch },
            } = result;
            const { condition, cases, defaultValue } = materialSwitch;

            const materialId =
              cases.find((item) => item.key === condition)?.value ||
              defaultValue;

            if (materialId) {
              return world.materialManager
                .getMaterial$(materialId)
                .pipe(map((material) => ({ ...result, material })));
            } else {
              return of(result);
            }
          })
        )
      )
    )

    .subscribe(({ object3D, material }) => {
      if (object3D && material && object3D.material !== material) {
        object3D.material = material;
      }
      world.change$.next();
    });
};

export default MaterialSwitchSystem;
